import { useNavigate } from "react-router-dom";
import AddNewAnketa from "./AddNewAnketa";
import Background from "../../components/Background4.jsx";

const AddNewAnketaPage = () => {
  const navigate = useNavigate();

  const handleAddAnketa = async (novaAnketa) => {
    try {
      navigate("/zaposleni/ankete/sve");
    } catch (error) {
    }
  };

  return (
    <div>
      <Background />
      <AddNewAnketa onSubmit={handleAddAnketa} />
    </div>
  );
};

export default AddNewAnketaPage;
